import UrlParse from 'url-parse';

export function getUrlParams(top = false) {
  const url = top ? window.top.location.href : window.location.href;
  const parsedUrl = new UrlParse(url);
  const params = new URLSearchParams(parsedUrl.query);

  return Object.fromEntries(params.entries());
}

/**
 * Yields to the main thread to prevent blocking the UI
 * @returns {Promise<unknown>}
 * @see https://www.corewebvitals.io/pagespeed/yield-to-main-thread
 */
export async function yieldToMain() {
  if ('scheduler' in window && 'yield' in window.scheduler) {
    // eslint-disable-next-line no-return-await
    return await window.scheduler.yield();
  }
  return new Promise(resolve => {
    setTimeout(resolve, 0);
  });
}
